import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { CreateemployeeComponent } from '../createemployee/createemployee.component';

@Component({
  selector: 'app-edit-view-employees',
  templateUrl: './edit-view-employees.component.html',
  styleUrls: ['./edit-view-employees.component.scss']
})
export class EditViewEmployeesComponent implements OnInit {

  @ViewChild('eduModal')
  eduModal: any;
  @ViewChild('successModal')
  alertModal: any;

  LoaderComponent: any = '';
  multiDropdownSettings: any = {};
  multiSelectRegionDropdown: any = {};
  loginData: any;
  empID: any = "";
  regionArray: any = [];
  selectedRegion: any;
  selectedRegionList: any = [];
  selectedBranchList: any = [];
  branchMultiSelectItems: any = [];
  selectedBranch: any;
  empNameMultiSelectItems: any = [];
  singleSelectionDropdown: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  selectedEmployeeList: any = [];
  logeedInUser: any;
  branchDetails: any;
  employeeSearchForm: FormGroup;
  hoursArray: any = [];
  minutesArray: any = [];
  allBranchIPs: any[] = [];
  branchIPData: any = {};
  allBranches: any[] = [];
  defaultAll: any;
  gridType: any = 'branch';
  matchedHeaders: any[] = [];
  headers: any[] = [];
  responseMessage: any;
  searchEmpObj: any;
  employeeArray: any[] = [];
  loginFrom: any;
  loginTo: any;
  districtArray: any;
  stateArray: any;
  countryArray: any;
  isIndia: any;
  isInList: any;
  cityArray: any;
  addEmployeeForm: FormGroup;
  employeeTypeArray: any;
  employeeStatusArray: any;
  createEmpObj: any;
  branchArray: any[] = [];
  branchArrayList: any;
  employeeDesignation: any;
  weekOffArray: any;
  multiDropdownSettingsSingle: any;
  teamHeadArray: any;
  educationcategory: any;
  professionalArray: any[];
  professionArray: any[];
  educationGroupArray: any[];
  educationSepliziationArray: any[];
  DateOfJoining: any;
  employeeLoginId: any[] = [];
  employeeId: boolean = false;
  employeeCreateMsg: any;
  employeeArrayList: any;
  createBranchID: any;
  passwordField = true;
  selectHours: any = []
  selectMunit: any = []
  timecount: any;
  empBranch: any;
  multiDropdownSettingsSingle1: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; closeDropDownOnSelection: boolean; };
  employeeData: any;
  deleteEmployeeDOJ: any;

  constructor(public service: WebRequestService,
    private loginDataStore: Data, public dialog: MatDialog) { }

  ngOnInit(): void {
    // this.hoursArray = this.bindHoursMinutes(0, 23, 'Hrs', 1)
    this.minutesArray = [
      { id: 0, value: '00' },
      { id: 1, value: '30' }];
    // this.weekOffArray = [
    //   { id: 1, value: 'Monday' },
    //   { id: 2, value: 'Tuesday' },
    //   { id: 3, value: 'Wednesday' },
    //   { id: 4, value: 'Thursday' },
    //   { id: 5, value: 'Friday' },
    //   { id: 6, value: 'Saturday' },
    //   { id: 7, value: 'Sunday' }]

    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
        console.log(this.loginData)
      })
    this.service
      .loadMasterData('Country')
      .then((response) => {
        this.countryArray = response['result'];
        //console.log();
      })
      .catch((err) => console.log(err));
    this.service.loadMasterData('HighestEducation').then((response) => {
      this.educationcategory = response['result'];
    });
    this.multiDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.multiDropdownSettingsSingle = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
    this.multiDropdownSettingsSingle1 = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };

    this.multiSelectRegionDropdown = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    }
    this.loadBasicData();
    this.allBranches = [
      { id: '', Value: 'All' },
      { id: '408', Value: 'AP' },
      { id: '409', Value: 'TN' },
      { id: '410', Value: 'KT' },
      { id: '1', Value: 'Other' }
    ];

    this.hoursArray = this.numberBindWithZeros('Hours', 0, 23);
    this.minutesArray = this.numberBindWithZeros('Minutes', 0, 59);
    // this.secondsArray = this.numberBindWithZeros('Seconds', 0, 59);

    this.employeeSearchForm = new FormGroup({
      branchName: new FormControl(''),
      regionName: new FormControl(''),
      employeeStatus: new FormControl(''),
      employeeType: new FormControl(''),
      loginAnywhere: new FormControl('')
    })
    this.addEmployeeForm = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      email: new FormControl(''),
      workingBranch: new FormControl(''),
      officeLandline: new FormControl(''),
      officialPhone: new FormControl(''),
      designation: new FormControl(''),
      loginLocation: new FormControl(''),
      weekOff: new FormControl(''),
      dateOfJoining: new FormControl(''),
      officeHoursFrom: new FormControl(''),
      officeMinsFrom: new FormControl(''),
      officeHoursTo: new FormControl(''),
      officeMinsTo: new FormControl(''),
      loginName: new FormControl(''),
      loginHoursFrom: new FormControl(''),
      loginMinsFrom: new FormControl(''),
      loginHoursTo: new FormControl(''),
      loginMinsTo: new FormControl(''),
      educationCategory: new FormControl(''),
      educationGroup: new FormControl(''),
      eduSpecialization: new FormControl(''),
      empType: new FormControl(''),
      loadDashboard: new FormControl(''),
      loginAnywhereCreate: new FormControl(''),
      country: new FormControl(''),
      state: new FormControl(''),
      district: new FormControl(''),
      city: new FormControl(''),
      address: new FormControl(''),
      personalEmail: new FormControl(''),
      personalPhone: new FormControl(''),
      alternatePhone: new FormControl(''),
      password: new FormControl(''),
      isTeamHead:new FormControl(''),
      teamHead: new FormControl(''),
      smartPhone: new FormControl('')


    })




    //     newStr = str.split(''); // or newStr = [...str];
    // newStr.splice(2,5);
    // newStr = newStr.join('');
  }

  bindHoursMinutes(fromval, Toval, str, incrementval) {
    let options = [];
    options.push({ label: str, title: str, value: "" });
    for (let i = fromval; i <= Toval; i += incrementval) {
      if (i < 10) {
        options.push({ label: "0" + i + " " + str, title: "0" + i + " " + str, value: +(parseInt(i) + 1) });
      } else {

        options.push({ label: i + " " + str, title: i + " " + str, value: +(parseInt(i) + 1) });
      }
    }
    return options;
  };
  selectedEduCategory(data) {
    this.educationGroupArray = [];
    this.LoaderComponent = LoaderComponent;
    this.service
      .loadMasterDataWithId('EducationDegree', data['id'])
      .then((response) => {
        this.LoaderComponent = '';
        this.educationGroupArray = response['result'];
        this.addEmployeeForm.patchValue({
          educationGroup: '',
        });
      })
      .catch((err) => console.log(err));
  }


  selectedEduGrp(data) {
    this.educationSepliziationArray = [];
    this.LoaderComponent = LoaderComponent;
    this.service
      .loadMasterDataWithId('Specialization', data['id'])
      .then((response) => {
        this.LoaderComponent = '';
        this.educationSepliziationArray = response['result'];
        this.addEmployeeForm.patchValue({
          eduSpecialization: '',
        });
      })
      .catch((err) => console.log(err));
  }

  _convertDate(date) {
    console.log(date, 'post')
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;
    console.log([month, day, year].join('/'))
    return [month, day, year].join('/');
  }
  //   _convertDatePatch(date) {
  //     console.log(date,'get')
  //     let d = new Date(date),
  //       month = '' + (d.getMonth() + 1),
  //       day = '' + d.getDate(),
  //       year = d.getFullYear();

  //     month.length < 2 ? (month = '0' + month) : month;
  //     day.length < 2 ? (day = '0' + day) : month;
  // console.log([day, month, year].join('/'))
  //     return [month, day, year].join('/');
  //   }
  onKeypressEvent(evt) {
    var iKeyCode = (evt.which) ? evt.which : evt.keyCode
    if (iKeyCode != 47 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
      return false;
    return true;
  }
  getConvertedDateOfBirth(type, dob) {
    if (type === 'patch') {
      // let x = dob.split('(');
      // let day = moment(x[0]);
      let day = moment(dob, "DD-MM-YYYY").toDate();
      return day;
    } else {
      let day = moment(dob);
      return day.format('YYYY/MM/DD hh:mm:ss A');
    }
  }

  // onBranchSelect(event) {
  //   console.log(event.id)
  //   this.service.createEmployeeIDByBranch(event.id).then((res) => {
  //     this.employeeLoginId = res['result']
  //     this.employeeId = true;
  //     console.log(this.employeeLoginId)
  //   }).catch((err) => { console.log(err) })
  // }
  createEmployee(event) {

    console.log(this.addEmployeeForm.value)

    this.passwordField = true;

    const officeFromTime = this.convertTime(this.addEmployeeForm.value['officeHoursFrom'],
      this.addEmployeeForm.value['officeMinsFrom']);
    const officeToTime = this.convertTime(this.addEmployeeForm.value['officeHoursTo'],
      this.addEmployeeForm.value['officeMinsTo']);
    const fromTime = this.convertTime(this.addEmployeeForm.value['loginHoursFrom'],
      this.addEmployeeForm.value['loginMinsFrom']);
    const toTime = this.convertTime(this.addEmployeeForm.value['loginHoursTo'],
      this.addEmployeeForm.value['loginMinsTo']);
    this.createEmpObj = {

      firstName: this.addEmployeeForm.value['firstName'] != ''
        ? this.addEmployeeForm.value['firstName']
        : '',
      lastName: this.addEmployeeForm.value['lastName'] != ''
        ? this.addEmployeeForm.value['lastName']
        : '',
      officialEmailID: this.addEmployeeForm.value['email'] != ''
        ? this.addEmployeeForm.value['email']
        : '',
      homeBranchID: this.addEmployeeForm.value.workingBranch.id > 0 ?
        this.addEmployeeForm.value.workingBranch.id
        : null,
      workPhone: this.addEmployeeForm.value['officeLandline'] != ''
        ? this.addEmployeeForm.value['officeLandline']
        : '',
      officialCellPhone: this.addEmployeeForm.value['officialPhone'] != ''
        ? this.addEmployeeForm.value['officialPhone']
        : '',
      homePhone: this.addEmployeeForm.value['personalPhone'] != ''
        ? this.addEmployeeForm.value['personalPhone']
        : '',
      personalEmailID: this.addEmployeeForm.value['personalEmail'] != ''
        ? this.addEmployeeForm.value['personalEmail']
        : '',
      loginName: this.employeeLoginId[0]['loginName'] != ''
        ? this.employeeLoginId[0]['loginName']
        : '',
      password: this.addEmployeeForm.value['password'] != ''
        ? this.addEmployeeForm.value['password']
        : '',
      designation: this.addEmployeeForm.value.designation[0].id > 0 ?
        this.addEmployeeForm.value.designation[0].id
        : null,
      loginLocation: this.addEmployeeForm.value.loginLocation &&
        this.addEmployeeForm.value.loginLocation.length !== 0
        ? this.addEmployeeForm.value.loginLocation.length > 1
          ?
          String(this.addEmployeeForm.value.loginLocation.map((val) => {
            return val.id;
          })
          )
          : String(this.addEmployeeForm.value.loginLocation[0].id)
        : null,
      officeFromHrs: officeFromTime != null ? officeFromTime : null,
      officeToHrs: officeToTime != null ? officeToTime : null,
      dayOff: this.addEmployeeForm.value.weekOff[0].id > 0
        ? this.addEmployeeForm.value.weekOff[0].id
        : null,
      dateofJoining:
        this.addEmployeeForm.value['dateOfJoining'] != ''
          ? this.getConvertedDateOfBirth(
            'saveObject',
            this.addEmployeeForm.value['dateOfJoining']
          )
          : '',
      dateofReleaving: "",
      reportingMngrID: null,
      annualIncome: "",
      country: this.addEmployeeForm.value['country']
        ? this.addEmployeeForm.value['country'][0]['id']
        : null,
      state: this.addEmployeeForm.value['state']
        ? this.addEmployeeForm.value['state'][0]['id']
        : null,
      district: this.addEmployeeForm.value['district']
        ? this.addEmployeeForm.value['district'][0]['id']
        : null,
      city: this.addEmployeeForm.value['city']
        ? this.addEmployeeForm.value['city'][0]['id']
        : null,
      cityOther: "",
      address: this.addEmployeeForm.value['address'] != ''
        ? this.addEmployeeForm.value['address']
        : '',
      educationCategory: this.addEmployeeForm.value['educationCategory'] &&
        this.addEmployeeForm.value['educationCategory'].length > 0
        ? this.addEmployeeForm.value['educationCategory'][0]['id']
        : 0,
      educationGroup: this.addEmployeeForm.value['educationGroup'] &&
        this.addEmployeeForm.value['educationGroup'].length > 0
        ? this.addEmployeeForm.value['educationGroup'][0]['id']
        : 0,
      educationSpecialization: this.addEmployeeForm.value['eduSpecialization'] &&
        this.addEmployeeForm.value['eduSpecialization'].length > 0
        ? this.addEmployeeForm.value['eduSpecialization'][0]['id']
        : 0,
      employeeImgPath: "",
      typeOfEmployee:
        this.addEmployeeForm.value['empType'][0].id > 0
          ? Number(this.addEmployeeForm.value['empType'][0].id)
          : null,
      employeeStatus: null,
      createdEMPID: this.loginData['employeeID'],
      empid: null,
      isLoginAnywhere: this.addEmployeeForm.value['loginAnywhereCreate'] ? true : false,
      dashboard_Status: this.addEmployeeForm.value['loadDashboard'] != null ? Number(this.addEmployeeForm.value['loadDashboard']) : null,
      loginfrom: fromTime != null ? fromTime : null,
      loginto: toTime != null ? toTime : null,
      isSmartPh: this.addEmployeeForm.value['smartPhone'] ? 1 : 0,
      alternateNumber: this.addEmployeeForm.value['alternatePhone'] != ''
        ? this.addEmployeeForm.value['alternatePhone']
        : '',
      teamHeadID: this.addEmployeeForm.value.teamHead[0].id > 0
        ? this.addEmployeeForm.value.teamHead[0].id
        : null,
      genderID: 0


    }

    console.log(this.createEmpObj)

    this.service.createEmployees(this.createEmpObj).then((res) => {
      if (res['statusCode'] === 200) {
        this.responseMessage = res['response'];
        this.alertModal.show();
        console.log(this.employeeCreateMsg);
      }
    }).catch((err) => console.error(err));





  }

  getEmployees(event) {
    // console.log(this.employeeSearchForm.value.employeeStatus.id)
    this.searchEmpObj = {
      empID: null,
      branchID: this.employeeSearchForm.value.branchName &&
        this.employeeSearchForm.value.branchName.length !== 0
        ? this.employeeSearchForm.value.branchName.length > 1
          ?
          String(this.employeeSearchForm.value.branchName.map((val) => {
            return val.id;
          })
          )
          : String(this.employeeSearchForm.value.branchName[0].id)
        : null,
      empStatus: this.employeeSearchForm.value.employeeStatus.id ? this.employeeSearchForm.value.employeeStatus.id : null,
      empTypeID: this.employeeSearchForm.value.employeeType.id ? this.employeeSearchForm.value.employeeType.id : null,
      isLoginanywhere: this.employeeSearchForm.value['loginAnywhere'] ? true : false,
      regionID: this.employeeSearchForm.value.regionName &&
        this.employeeSearchForm.value.regionName.length !== 0
        ? this.employeeSearchForm.value.regionName.length > 1
          ? String(
            this.employeeSearchForm.value.regionName.map((val) => {
              return String(val.id);
            })
          )
          : String(this.employeeSearchForm.value.regionName[0].id)
        : null,
      startIndex: 1,
      endIndex: 100
    }
    this.employeeArray = [];
    this.service.getAllEmployeeList(this.searchEmpObj).then((res) => {
      if (res['statusCode'] === 200) {
        this.employeeArray = res['result'];
        console.log(this.employeeArray);
      }
    }).catch((err) => console.error(err));
  }
  editEmployeeDetails(empData) {
    console.log(empData)
    this.service.createEmployees(empData).then((res) => {
      if (res['statusCode'] === 200) {
        this.employeeArrayList = res['result'];
        console.log(this.employeeArrayList);
      }
    }).catch((err) => console.error(err));
  }

  // getConvertedDateOfBirth(type, dob) {
  //   if (type === 'patch') {
  //     // let x = dob.split('(');
  //     // let day = moment(x[0]);
  //     let day = moment(dob, "DD-MM-YYYY").toDate();
  //     return day;
  //   } else {
  //     let day = moment(dob);
  //     return day.format('YYYY/MM/DD hh:mm:ss A');
  //   }
  // }
  activateEmployee(employeeData) {
    employeeData.employeeStatus = 423;
    employeeData.isSmartPh ? (employeeData.isSmartPh = 1) : (employeeData.isSmartPh = 0);
    this.service.createEmployees(employeeData).then((res) => {
      if(res['statusCode'] === 200) {
        this.responseMessage = 'Employee Profile Activated successfully';
        this.alertModal.show();
        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      } else if (res['statusCode'] === 409) {
        this.responseMessage = res['message'];
        this.alertModal.show();
      }
    }).catch((err) => console.error(err));
  }

  deleteEmployee(employeeData) {
    employeeData.employeeStatus = 424;
    this.deleteEmployeeDOJ = employeeData['deleteDOJ']
    employeeData.dateOfJoining = this.deleteEmployeeDOJ
    if (employeeData.isSmartPh) {
      employeeData.isSmartPh = 1;
    } else {
      employeeData.isSmartPh = 0;
    }
    // employeeData.dateOfJoining = this.getConvertedDateOfBirth('delete',employeeData.dateOfJoining)


    console.log(employeeData)
    this.service.createEmployees(employeeData).then((res) => {
      if (res['statusCode'] === 200) {
        this.responseMessage = 'Employee Profile Deleted Successfully';
        this.alertModal.show();

        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      } else if (res['statusCode'] === 409) {
        this.responseMessage = res['message'];
        this.alertModal.show();
        // setTimeout(() => {
        //   this.alertModal.hide();
        // }, 5000);
      }
    }).catch((err) => console.error(err));
  }
  disableEmployee(employeeData) {
    employeeData.employeeStatus = 425;
    this.deleteEmployeeDOJ = employeeData['deleteDOJ']
    employeeData.dateOfJoining = this.deleteEmployeeDOJ
    if (employeeData.isSmartPh) {
      employeeData.isSmartPh = 1;
    } else {
      employeeData.isSmartPh = 0;
    }

    console.log(employeeData)
    this.service.createEmployees(employeeData).then((res) => {
      if (res['statusCode'] === 200) {
        this.responseMessage = 'Employee Profile Disabled Successfully';
        this.alertModal.show();
        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      } else if (res['statusCode'] === 409) {
        this.responseMessage = res['message'];
        this.alertModal.show();
        // setTimeout(() => {
        //   this.alertModal.hide();
        // }, 5000);
      }
    }).catch((err) => console.error(err));
  }

  loadBasicData() {
    this.empID = sessionStorage.getItem('empId')
    this.service.getMasterData().then((response) => {
      if (response['statusCode'] === 200) {
        console.log(response['result']);

        this.regionArray = response['result'][1];
        this.branchArray = response['result'][2];
        this.teamHeadArray = response['result'][6];
        // this.branchArrayList = response['result'][2].name;
        console.log(this.regionArray)

        this.selectedRegion = [this.getRegion(this.loginData['region'])]
        this.selectedRegionList.push(parseInt(this.loginData['region']))
        this.service.loadMasterDataWithId('StateLocation', this.loginData['region']).then((branchResult) => {
          this.branchMultiSelectItems = branchResult['result'];
          this.selectedBranch = [this.getBranch(this.loginData['branch'])];
        })
          .catch((err) => console.error(err));
      }
    })
    this.service.loadMasterData('EmployeeType').then((res) => {
      if (res['statusCode'] === 200) {
        this.employeeTypeArray = res['result'];

      }
    }).catch((err) => { console.log(err) })
    this.service.loadMasterData('EmployeeWeekOff').then((res) => {
      if (res['statusCode'] === 200) {
        this.weekOffArray = res['result'];

      }




    }).catch((err) => { console.log(err) })
    this.service.loadMasterData('EmpDesignation').then((res) => {
      if (res['statusCode'] === 200) {
        this.employeeDesignation = res['result'];
        console.log(this.employeeDesignation)

      }

    }).catch((err) => { console.log(err) })

    this.service.loadMasterData('EmployeeStatus').then((res) => {
      if (res['statusCode'] === 200) {
        this.employeeStatusArray = res['result'];
      }

    }).catch((err) => { console.log(err) })
  }

  getBranch(id) {
    return this.branchMultiSelectItems.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }
  getRegion(id) {
    return this.regionArray.find(val => {
      if (id == val.id) {
        return val.id;
      }
    })
  }

  getSelectedRegion(event) {
    if (this.selectedRegionList.indexOf(event.id) == -1) {
      this.LoaderComponent = LoaderComponent;
      this.branchMultiSelectItems = [];
      this.selectedRegionList.push(event.id);
      this.service
        .loadMasterDataWithId('StateLocation', this.selectedRegionList)
        .then((branchResult) => {
          if (branchResult['statusCode'] === 200) {
            this.LoaderComponent = "";
            this.selectedBranch = "";
            this.branchMultiSelectItems = branchResult['result'];
            this.logeedInUser = "";
            this.empNameMultiSelectItems = [];
          }
        })
        .catch((err) => { console.error(err) });
    }
  }

  onRegionDeSelect(event) {
    let index = this.selectedRegionList.indexOf(event.id);
    console.log('region', index)
    console.log(this.selectedRegionList)
    if (index > -1) {
      this.selectedRegionList.splice(index, 1);
      console.log(this.selectedRegionList)
      this.branchMultiSelectItems = [];
      this.service
        .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
        .then((empResult) => {
          this.branchMultiSelectItems = empResult['result'];
        })

    }

  }

  onRegionDeSelectAll(event) {
    this.selectedRegionList = event;
    this.branchMultiSelectItems = [];
  }

  onRegionSelectAll(event) {
    console.log(event)
    this.selectedRegionList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedRegionList.push(event[i]['id'])
    }
    this.branchMultiSelectItems = [];
    console.log('branch', this.selectedRegionList)
    this.service
      .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
      .then((empResult) => {
        this.branchMultiSelectItems = empResult['result'];
      })
  }


  onBranchItemSelect(event) {
    if (this.selectedBranchList.indexOf(event.id) > -1) {
      let index = this.selectedBranchList.indexOf(event.id);
      this.selectedBranchList.splice(index, 1);
    } else {
      this.empNameMultiSelectItems = [];
      this.selectedBranchList.push(event.id);
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];

        })
    }
  }

  onBranchItemDeSelect(event) {
    let index = this.selectedBranchList.indexOf(event.id);
    if (index >= 0) {
      this.selectedBranchList.splice(index, 1);
      this.empNameMultiSelectItems = [];
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];
        })

    }

  }

  onBranchDeSelectAll(event) {
    this.selectedBranchList = event;
    this.empNameMultiSelectItems = [];
  }
  onBrachItemsSelectAll(event) {
    this.selectedBranchList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedBranchList.push(event[i]['id'])
    }
    this.empNameMultiSelectItems = [];
    this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
      .then((empResult) => {
        this.empNameMultiSelectItems = empResult['result'];
      })
  }

  openCreateEmployeeForm(employee?) {

    this.employeeData = employee;


    // const dialogRef = this.dialog.open(CreateemployeeComponent, {
    //   height: '92%',
    //   width: '95%',
    //   maxWidth: '95%',
    //   panelClass:'createEmployeeDialog',
    //   data: {editEmployeeDataFromSearch: this.employeeData },

    // })
  }

  openEmployeeForm(type, employee?) {
    switch (type) {
      case 'edit':
        this.employeeData = employee;
        this.passwordField = false;
        // this.editEmployeeForm(employee);
        const dialogRef = this.dialog.open(CreateemployeeComponent, {
          height: '92%',
          width: '95%',
          maxWidth: '95%',
          panelClass: 'createEmployeeDialog',
          data: { editEmployeeDataFromSearch: this.employeeData,
             isEdit: true, branchesArray: this.branchArray,
             },

        })
        break;
      case 'add':
        this.addEmployeeForm.reset();
        this.isIndia = false;
        // this.eduModal.show();
        const dialogRef1 = this.dialog.open(CreateemployeeComponent, {
          height: '92%',
          width: '95%',
          maxWidth: '95%',
          panelClass: 'createEmployeeDialog',
          data: { editEmployeeDataFromSearch: this.employeeData, isEdit: false,
            branchesArray: this.branchArray },

        })
        break;
      case 'delete':
        let deleteEmployee = employee;
        deleteEmployee.employeeStatus = 424;
        console.log(deleteEmployee)
        this.editEmployeeForm(deleteEmployee);
        break;
    }

  }


  selectedDistrict(event) {
    this.cityArray = [];
    this.LoaderComponent = LoaderComponent;
    this.service
      .loadMasterDataWithId('City', event['id'])
      .then((response) => {
        this.LoaderComponent = '';
        this.cityArray = response['result'];
        this.addEmployeeForm.patchValue({
          city: '',
        });

      })
      .catch((err) => console.log(err));
  }
  selectedState(event) {
    this.districtArray = [];
    this.cityArray = [];
    this.LoaderComponent = LoaderComponent;
    this.service
      .loadMasterDataWithId('District', event['id'])
      .then((response) => {
        this.LoaderComponent = '';
        this.districtArray = response['result'];
        this.cityArray = [];
        this.addEmployeeForm.patchValue({
          district: '',
          city: ''
        });

      })
      .catch((err) => console.log(err));
    if (!this.isIndia) {
      this.cityArray = [];
      this.LoaderComponent = LoaderComponent;
      this.service
        .loadMasterDataWithId('District', event['id'])
        .then((response) => {
          this.LoaderComponent = '';
          this.cityArray = response['result'];
          this.addEmployeeForm.patchValue({
            city: '',
          });
        })
        .catch((err) => console.log(err));
    }
  }
  selectedCountry(event) {
    this.stateArray = [];
    this.districtArray = [];
    this.cityArray = [];
    this.LoaderComponent = LoaderComponent;
    this.service
      .loadMasterDataWithId('State', event['id'])
      .then((response) => {
        this.LoaderComponent = '';
        this.stateArray = response['result'];
        this.addEmployeeForm.patchValue({
          state: '',
          city: '',
          district: ''

        });
      })
      .catch((err) => console.log(err));
  }

  removeSelectedCountry() {
    this.stateArray = [];
    this.districtArray = [];
    this.cityArray = [];
    this.addEmployeeForm.patchValue({
      state: '',
      district: '',
      city: ''
    })

  }
  removeSelectedState() {
    this.districtArray = [];
    this.cityArray = [];
    this.addEmployeeForm.patchValue({
      district: '',
      city: ''
    })

  }
  removeSelectedDistrict() {
    this.cityArray = [];
    this.addEmployeeForm.patchValue({
      city: ''
    })

  }
  numberBindWithZeros(str, from, to) {
    var numArr = [];
    var y;
    numArr.push({ "value": str, "title": str, "id": '' });
    for (var x = from; x <= to; x++) {
      if (x < 10)
        y = ("0" + x);
      else
        y = x;
      numArr.push({ "value": y, "title": y, "id": parseInt(y) });
    }
    return numArr;
  }

  onSelectData(type, e) {
    if (type == 'hours') {
      this.selectHours = `${e.value}`
    } else {
      this.selectMunit = `${e.value}`
    }
    if (this.selectHours.length !== 0 && this.selectMunit.length !== 0) {
      this.timecount = this.timeConvert(`${this.selectHours}:${this.selectMunit}`)
      // this.birthText = this.timecount.includes("AM") ? "Early hours :" : "Late hours :"
    }
  }

  timeConvert(time) {
    time = time ? time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time] : '';

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time ? time.join('') : ''; // return adjusted time or original string
  }

  convertTime(hours, minutes) {
    let h, m, time = "";

    if (hours && hours.length > 0) {
      h = hours[0]['id']
    }
    if (minutes && minutes.length > 0) {
      m = minutes[0]['id']
    }
    time = (hours != '' && minutes != '') ? (h + ':' + m) : '00 : 00';
    return time;
  }

  getHours(id) {
    return this.hoursArray.find(val => val.id == id);

  }
  getMinutes(id) {
    return this.minutesArray.find(val => val.id == id)
  }
  // getSeconds(id) {
  //   return this.secondsArray.find(val => val.id == id)
  // }
  // getConvertedDateOfBirth( dob) {

  //     // let x = dob.split('(');
  //     // let day = moment(x[0]);
  //     let day = moment(dob, "DD-MM-YYYY").toDate();
  //     return day;

  // }

  editEmployeeForm(employee) {
    this.passwordField = false;
    this.empBranch = this.branchArray.filter(branch => branch.id === employee.homeBranchID)[0];
    this.employeeLoginId = [{ LoginName: employee['loginName'] }]
    console.log(this.employeeLoginId[0].LoginName)

    let time, fromTime, toTime, officeFromTime, officeToTime = "";
    if (employee && employee['officeFromHrs'] != null) {
      officeFromTime = ((employee['officeFromHrs']).split(' '))[0].split(':')
    }
    if (employee && employee['officeToHrs'] != null) {
      officeToTime = ((employee['officeToHrs']).split(' '))[0].split(':')
    }
    if (employee && employee['loginfrom'] != null) {
      fromTime = ((employee['loginfrom']).split(' '))[0].split(':')
    }
    if (employee && employee['loginto'] != null) {
      toTime = ((employee['loginto']).split(' '))[0].split(':')
    }
    this.addEmployeeForm.patchValue({
      firstName:
        employee['firstName'] != null
          ? employee['firstName'].toString()
          : '',
      lastName:
        employee['lastName'] != null
          ? employee['lastName'].toString()
          : '',
      email:
        employee['officialEmailID'] != null
          ? employee['officialEmailID'].toString()
          : '',
      // loginName: employee['loginName'],
      // password:
      //   employee['password'] != null
      //     ? employee['password'].toString()
      //     : '',
      workingBranch:
        employee['homeBranchID'] != null
          ? { id: employee.homeBranchID, value: employee.branchesName }
          : '',
      officeLandline:
        employee['workPhone'] != null
          ? employee['workPhone'].toString()
          : '',
      officialPhone:
        employee['officialCellPhone'] != null
          ? employee['officialCellPhone'].toString()
          : '',
      designation: [{ id: employee['designation'], value: employee['designationValue'] }],
      teamHead: employee['teamHeadID'] != null
        ? [{ id: employee['teamHeadID'], name: employee['teamLeadValue'] }]
        : '',
      weekOff: employee['dayOff'] != null ? [{ id: employee['dayOff'], value: employee['dayOffValue'] }] : '',
      empType: employee['typeOfEmployee'] != null ? [{ id: employee['typeOfEmployee'], value: employee['typeOfEmployeeValue'] }] : '',
      loginLocation:
        employee['loginLocation'] != null
          ? [{
            id: employee['loginLocation'],
            name: employee['branchesName']
          }]
          : '',
      dateOfJoining:
        this.getConvertedDateOfBirth(
          'patch',
          employee['dateOfJoining']
        ),

      educationCategory:
        employee['educationCategory'] != null
          ? [
            {
              id: employee['educationCategory'],
              value: employee['educationCategoryName'],
            },
          ]
          : '',
      educationGroup:
        employee['educationGroup'] != null
          ? [
            {
              id: employee['educationGroup'],
              value: employee['educationGroupName'],
            },
          ]
          : '',
      educationSpecialization:
        employee['educationSpecialization'] != null
          ? [
            {
              id: employee['educationSpecialization'],
              value: employee['educationSpecializationName'],
            },
          ]
          : '',
      country:
        employee['country'] != null
          ? [{ id: employee['country'], value: employee['countryName'] }]
          : '',
      state:
        employee['state'] != null
          ? [{ id: employee['state'], value: employee['stateName'] }]
          : '',
      district:
        employee['district'] != null
          ? [{ id: employee['district'], value: employee['districtName'] }]
          : '',
      city:
        employee['city'] != null
          ? [{ id: employee['city'], value: employee['cityName'] }]
          : '',
      smartPhone:
        employee['isSmartPh'] ?
          true : false,
      officePhone:
        employee['officialCellPhone'] != null
          ? employee['officialCellPhone']
          : '',
      officeHoursFrom:
        employee['officeFromHrs'] != null && officeFromTime != '' && officeFromTime.length > 0
          ? [this.getHours(officeFromTime[0])]
          : '',
      officeHoursTo:
        employee['officeToHrs'] != null && officeToTime != '' && officeToTime.length > 0
          ? [this.getHours(officeToTime[0])]
          : '',
      officeMinsFrom:
        employee['officeFromHrs'] != null && officeFromTime != '' && officeFromTime.length > 0
          ? [this.getMinutes(officeFromTime[1])]
          : '',
      officeMinsTo:
        employee['officeToHrs'] != null && officeToTime != '' && officeToTime.length > 0
          ? [this.getMinutes(officeToTime[1])]
          : '',
      loginHoursFrom:
        employee['loginfrom'] != null && fromTime != '' && fromTime.length > 0
          ? [this.getHours(fromTime[0])]
          : '',
      loginHoursTo:
        employee['loginto'] != null && toTime != '' && toTime.length > 0
          ? [this.getHours(toTime[0])]
          : '',
      loginMinsFrom:
        employee['loginfrom'] != null && fromTime != '' && fromTime.length > 0
          ? [this.getMinutes(fromTime[1])]
          : '',
      loginMinsTo:
        employee['loginto'] != null && toTime != '' && toTime.length > 0
          ? [this.getMinutes(toTime[1])]
          : '',
      personalEmail:
        employee['personalEmailID'] != null
          ? employee['personalEmailID']
          : '',
      personalPhone:
        employee['homePhone'] != null
          ? employee['homePhone']
          : '',
      alternatePhone:
        employee['alternateNumber'] != null
          ? employee['alternateNumber']
          : '',
      address:
        employee['address'] != null
          ? employee['address']
          : '',
      loginAnywhereCreate:
        employee['isLoginAnywhere'] != null
          ? employee['isLoginAnywhere']
          : '',
      loadDashboard:
        employee['dashboard_Status'] != null
          ? Number(employee['dashboard_Status'])
          : null,


    });
  }

}
